var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('main', {
    staticClass: "section main"
  }, [_c('div', {
    class: {
      showing: _vm.loadingMask
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "spinner"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content topmargin clearfix2"
  }, [_vm.tokenError ? _c('div', {
    staticStyle: {
      "padding": "30px 0",
      "text-align": "center"
    }
  }, [_vm._v("Oops, login expired, please log in\n                again")]) : _vm._e(), _vm._v(" "), _vm.noData ? _c('div', {
    staticClass: "no_data"
  }, [_vm._v(_vm._s(_vm.$t("noData")))]) : _vm._e(), _vm._v(" "), !_vm.noData && (_vm.personalId || _vm.userInfo.uid || _vm.serverRender) ? _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('main', {
    staticClass: "main"
  }, [_c('personal-info', {
    attrs: {
      "personalInfoList": _vm.personalInfoList,
      "bindList": _vm.bindList,
      "isSelf": _vm.isSelf,
      "targe": _vm.getLiveRoomLinkTarget('_black')
    },
    on: {
      "clickShowPop": _vm.clickShowPop,
      "clickFollowFriend": _vm.clickFollowFriend
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [_c('live-video', {
    attrs: {
      "liveList": _vm.liveList,
      "target": _vm.getLiveRoomLinkTarget()
    }
  }), _vm._v(" "), _c('personal-video', {
    attrs: {
      "countryCode": _vm.countryCode,
      "recommendList": _vm.recommendList,
      "shortsList": _vm.shortsList,
      "replayVideo": _vm.replayVideo,
      "showShortsActive": _vm.showShortsActive,
      "shortsVideo": _vm.shortsVideo,
      "target": _vm.getLiveRoomLinkTarget(),
      "shortsNoData": _vm.shortsNoData,
      "shortsNoMoreData": _vm.shortsNoMoreData
    },
    on: {
      "clickShowPop": _vm.clickShowPop
    }
  })], 1)], 1), _vm._v(" "), _c('biggest-fans', {
    attrs: {
      "biggestFansList": _vm.biggestFansList,
      "userInfo": _vm.userInfo,
      "countryCode": _vm.countryCode,
      "target": _vm.getLiveRoomLinkTarget()
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('popup-fans', {
    style: {
      display: _vm.fansPop
    },
    attrs: {
      "fansList": _vm.fansList,
      "followAndFansNoMoreData": _vm.followAndFansNoMoreData
    },
    on: {
      "clickFollowFriend": _vm.clickFollowFriend,
      "clickClosePop": _vm.clickClosePop
    }
  }), _vm._v(" "), _c('popup-follow', {
    style: {
      display: _vm.followPop
    },
    attrs: {
      "followingList": _vm.followingList,
      "followAndFansNoMoreData": _vm.followAndFansNoMoreData,
      "followAndFansLoading": _vm.followAndFansLoading
    },
    on: {
      "clickFollowFriend": _vm.clickFollowFriend,
      "clickClosePop": _vm.clickClosePop
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };